import request from '@/utils/request'
import { formatParam } from '@/utils/tool'

// 显示商户自己的个人资料+评分
export function getUserInfo (): any {
  return request('/saas/gtpw/mchUser/info', {
    method: 'GET'
  })
}

// 销售成就(数量 ,订单总额)
export function achievement (): any {
  return request('/saas/gtpw/mchUser/achievement', {
    method: 'GET'
  })
}

// 获取商户客服信息
export function loadCustomService (params): any {
  return request(`/saas/gtpw/mchUser/loadCustomService?${formatParam(params)}`, {
    method: 'GET'
  })
}

// 获取关联商家数量
export function countRelation (): any {
  return request('/saas/gtpw/mchUser/countRelation')
}

// 关联商家列表
export function mchUserData (params): any {
  return request(`/saas/gtpw/mchUser/data?${formatParam(params)}`)
}

// 商户修改个人资料
export function mchUserModify (data): any {
  return request('/saas/gtpw/mchUser/modify', {
    method: 'PUT',
    data
  })
}

// 获取运营商PC端登录地址
export function getLoginUrl (): any {
  return request('/saas/gtpw/mchUser/getLoginUrl')
}
